import { Banknote, LogOut, Settings, User, X } from "lucide-react";

// Menu Component
export const MenuOverlay = ({ show, onClose, currentUser, cashTotals, cashCollectionsCount, onMenuAction }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50" onClick={onClose}>
      <div className="absolute top-0 right-0 bg-white/10 backdrop-blur-lg border-l border-white/20 h-full w-64 p-4" onClick={e => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-white font-bold">Meniu</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white">
            <X className="w-5 h-5" />
          </button>
        </div>
        
        <div className="space-y-3">
          <div className="border-b border-white/20 pb-3 mb-4">
            <div className="flex items-center space-x-3 text-white">
              <User className="w-5 h-5" />
              <div>
                <p className="font-medium">{currentUser?.name || 'Șofer'}</p>
                <p className="text-sm text-gray-400">ID: {currentUser?.id || 'N/A'}</p>
              </div>
            </div>
          </div>

          <button 
            onClick={() => onMenuAction('cash')}
            className="w-full text-left flex items-center space-x-3 text-white hover:text-green-300 py-3 px-2 rounded-lg hover:bg-white/5 transition-colors relative"
          >
            <Banknote className="w-5 h-5" />
            <span>Cash de încasat</span>
            {cashTotals.pending > 0 && (
              <div className="absolute right-2 bg-green-500 text-white text-xs rounded-full px-2 py-0.5 min-w-[20px] text-center">
                {cashCollectionsCount}
              </div>
            )}
          </button>

          

          <div className="border-t border-white/20 pt-3 mt-4">
            <button 
              onClick={() => onMenuAction('logout')}
              className="w-full text-left flex items-center space-x-3 text-red-300 hover:text-red-200 py-3 px-2 rounded-lg hover:bg-red-500/10 transition-colors"
            >
              <LogOut className="w-5 h-5" />
              <span>Logout</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};